import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccSpecialist } from '../acc-specialists-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AccSpecialist, unknown>[] = [
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Text', row => row.fullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.assignedTopics, { header: 'Topics Assigned' }),
		buildColumn(util, 'Number', row => row.assignedEventsCount, { header: 'Events Assigned' }),
		buildColumn(util, 'Text', row => row.approvedLanguage, { header: 'Language' }),
		buildColumn(util, 'Text', row => row.approvedTopics, { header: 'Topics Approved', hidden: true }),
		buildColumn(util, 'FirstName', row => row.firstName, { header: 'First Name', hidden: true }),
		buildColumn(util, 'LastName', row => row.lastName, { header: 'Last Name', hidden: true }),
		buildColumn(util, 'Phone', row => row.phone, { header: 'Phone', hidden: true }),
		buildColumn(util, 'Email', row => row.email, { header: 'Email', hidden: true }),
		buildColumn(util, 'Text', row => row.cityAndState, { header: 'Location' }),
		buildColumn(util, 'Number', row => row.zip, { header: 'Zip Code', hidden: true }),
		buildColumn(util, 'Text', row => row.handbookSigned ? 'Signed' : 'Not Signed', { header: 'Handbook', hidden: true }),
		buildColumn(util, 'Text', row => row.mediaConsentSigned ? 'Signed' : 'Not Signed', { header: 'Media Consent', hidden: true }),
	];


	return columns;

}